import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { withoutBetaSegment } from './functions'

// Sends a retired `-beta` report address to the same place without the suffix, keeping the
// rest of the path, the query and the hash, and replacing the history entry so Back does not
// bounce straight into the redirect again.
const BetaPathRedirect = () => {
  const { pathname, search, hash } = useLocation()

  return (
    <Navigate
      replace
      to={{ pathname: withoutBetaSegment(pathname), search, hash }}
    />
  )
}

export default BetaPathRedirect
